/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
window.PXUTheme.jsHeader = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    this.section = $section[0].querySelector("[data-section-id]");
    this.sectionID = this.section.dataset.sectionId || null;

    // Selectors
    this.$el = $('#header')
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);

      $(window).on('resize', () => {
        this.enableSticky(announcementHeight);
      });
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
    }

    $('.search-overlay__close').on('click', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    // Кнопка Search — внизу файла: init зовётся только на load (MFS-5889)

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click touchstart', function(e) {
        var $this = $(this);
        window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave', function(){
        window.PXUTheme.jsHeader.collapseSubmenu($(this));
      });
    }

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      document.body.addEventListener('click', e => {
        if (e.target === document.querySelector('[data-site-overlay]')) {
          window.PXUTheme.jsHeader.hideSearch();
        }
      });
    }
  },
  toggleMenuClick: function(e, $this) {
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

    // Close dropdown if click anywhere outside dropdown menu
    $(window).on('click', function(e) {
      if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
      }
    });
  },
  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');

    setTimeout(function(){
      $stickyEl.css('height', 'auto');
    }, 250)
  },
  enableSticky: function(offset) {
    let $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 70,
      topSpacing: offset || 0
    })
    .on('sticky-start', () => {
      let headerHeight;
      let announcementHeight;

      // Hide the mini cart for centered header layout
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      // Get header height is sticky enabled
      if(window.PXUTheme.jsHeader.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
      }

      // Get announcement height is sticky enabled
      if(typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true)  {

        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();

      } else if (this.enable_overlay === true) {

        this.disableOverlayStyle();

      }
    })
    .on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      // Un-hide the mini cart when scrolled back to the top
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    })
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  SEARCH_WAIT_MS: 8000,
  searchWaitTimer: null,
  searchWaitExpired: false,

  boostModuleLoaded: function() {
    const boost = window.boostWidgetIntegration;
    return !!(boost && typeof boost.generateUuid === 'function');
  },

  searchReady: function() {
    // MFS-5978: свой поиск активен (snippets/search-gate.liquid) — виджет Boost не стартует, не ждём его
    if (window.MF_SEARCH && window.MF_SEARCH.active) return true;
    const boost = window.boostWidgetIntegration;
    const instantSearch = boost && boost.taeSettings && boost.taeSettings.instantSearch;
    if (!instantSearch || !instantSearch.enabled || this.searchWaitExpired) return true;
    if (document.body.classList.contains('boost-sd__search-widget-init-enabled')) return true;
    return !this.boostModuleLoaded() && document.readyState === 'complete';
  },

  waitForSearch: function(trigger) {
    if (this.searchWaitTimer) return;

    const startedAt = Date.now();
    const setWaiting = (waiting) => {
      if (!trigger) return;
      trigger.style.opacity = waiting ? '0.5' : '';
      trigger.style.cursor = waiting ? 'progress' : '';
      if (waiting) {
        trigger.setAttribute('aria-busy', 'true');
      } else {
        trigger.removeAttribute('aria-busy');
      }
    };

    const kickBoost = () => {
      const rect = trigger && trigger.getBoundingClientRect();
      document.dispatchEvent(new MouseEvent('mousemove', rect ? {
        clientX: rect.left + rect.width / 2,
        clientY: rect.top + rect.height / 2
      } : {}));
    };

    setWaiting(true);
    this.searchWaitTimer = setInterval(() => {
      if (!this.searchReady()) {
        if (Date.now() - startedAt < this.SEARCH_WAIT_MS) {
          if (this.boostModuleLoaded()) kickBoost();
          return;
        }
        this.searchWaitExpired = true;
      }
      clearInterval(this.searchWaitTimer);
      this.searchWaitTimer = null;
      setWaiting(false);
      this.openSearch(trigger, true);
    }, 100);
  },

  openSearch: function(trigger, force) {
    if (!force && !this.searchReady()) {
      this.waitForSearch(trigger);
      return;
    }

    const theme = window.PXUTheme;
    const jq = window.jQuery;
    const large = theme.media_queries && theme.media_queries.large
      ? theme.media_queries.large.matches
      : window.matchMedia('(min-width: 799px)').matches;

    this.lastSearchTrigger = trigger || null;

    if (!large && theme.theme_settings.enable_autocomplete && jq && theme.predictiveSearch) {
      if (document.querySelector('.mobile-search--visible')) return;
      theme.predictiveSearch.showMobileSearch();
      return;
    }

    const canOpen = theme.theme_settings.search_layout == 'overlay'
      ? jq && document.querySelector('[data-search-type="overlay"]') && theme.predictiveSearch
      : jq && jq.fancybox && document.querySelector('.js-search-popup');

    if (!canOpen) {
      window.location.href = (theme.routes && theme.routes.search_url) || '/search';
      return;
    }

    this.showSearch();
  },
  restoreSearchFocus: function() {
    const trigger = this.lastSearchTrigger;
    this.lastSearchTrigger = null;
    if (!trigger || !document.contains(trigger)) return;

    try {
      trigger.focus({ preventScroll: true });
    } catch (e) {
      trigger.focus();
    }
  },
  showSearch: function() {
    if (window.PXUTheme.theme_settings.search_layout != 'overlay' && $.fancybox.getInstance()) return;

    $('[data-show-search-trigger]').addClass('is-active');

    if(window.PXUTheme.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="overlay"]').addClass('is-opened');
      $('.search-form .search__fields input[type="text"]')[0].focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        touch: false,
        backFocus: false,
        beforeClose: function(){
          $('[data-show-search-trigger]').removeClass('is-active');
          window.PXUTheme.jsHeader.fadeOutBoostSuggestions();
        },
        afterShow: function() {
          // Поле — из окна: первое на странице бывает формой из контента (/search).
          // Set the cursor at the end of the input field for better UX,
          // otherwise it may be at the beginning of the input field when the input gets focus.
          const searchInputEl = $('.js-search-popup input[name="q"]')[0];
          if (!searchInputEl) return;
          searchInputEl.focus();
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
        },
        afterClose: function() {
          window.PXUTheme.jsHeader.resetBoostSuggestions();
          window.PXUTheme.jsHeader.restoreSearchFocus();
        },
      })
    }
  },

  BOOST_SUGGESTIONS: '.boost-sd__instant-search-container-desktop > .boost-sd__search-widget-init-wrapper, .boost-sd__instant-search-container-mobile > .boost-sd__search-widget-init-wrapper',
  fadeOutBoostSuggestions: function() {
    document.querySelectorAll(this.BOOST_SUGGESTIONS).forEach((wrapper) => {
      wrapper.style.transition = 'opacity .15s ease';
      wrapper.style.opacity = '0';
      wrapper.style.pointerEvents = 'none';
    });
  },
  resetBoostSuggestions: function() {
    document.querySelectorAll(this.BOOST_SUGGESTIONS).forEach((wrapper) => {
      wrapper.classList.add('boost-sd__g-hide');
      wrapper.style.transition = '';
      wrapper.style.opacity = '';
      wrapper.style.pointerEvents = '';
    });
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');

    if ($('.mobile-search').hasClass('mobile-search--visible') && window.PXUTheme.predictiveSearch) {
      window.PXUTheme.predictiveSearch.hideMobileSearch();
      return;
    }

    if(window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="'+window.PXUTheme.theme_settings.search_layout+'"]'));
    }
  },
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    $('.dropdown-click--true .header__link').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  },
  updateCartItemsCount(sectionsHTML) {
    const section = this.section || document.querySelector('.jsHeader [data-section-id]');
    const sectionID = this.sectionID || (section && section.dataset.sectionId);
    if (!section || !sectionID || !sectionsHTML || !sectionsHTML[sectionID]) return;

    const headerCartIcons = section.querySelectorAll(".header-cart");
    const headerContent = new DOMParser().parseFromString(sectionsHTML[sectionID], 'text/html');
    
    if (!headerContent) return;
    const updatedheaderCartIcons = headerContent.querySelectorAll(`.header-cart`);
    updatedheaderCartIcons.forEach((element, index) => {
      headerCartIcons[index].innerHTML = element.innerHTML;
    });
  }
};

(function () {
  const theme = window.PXUTheme;
  if (!theme || theme.searchTriggersBound) return;
  theme.searchTriggersBound = true;

  const TRIGGER = '[data-show-search-trigger], .searchItem';
  const SEARCH_FIELD = '.search-popup__form input[name="q"], .mobile-search input[name="q"], .boost-sd__search-bar-input';
  const SEARCH_SUBMIT = '.search-popup__form [type="submit"], .search-popup__form .submit-search';

  const header = () => window.PXUTheme.jsHeader;

  ['click', 'touchstart'].forEach((type) => {
    document.addEventListener(type, (e) => {
      const trigger = e.target.closest && e.target.closest('[data-show-search-trigger]');
      if (trigger && header()) header().lastSearchTrigger = trigger;
    }, { capture: true, passive: true });
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest && e.target.closest(TRIGGER);
    if (!trigger || !header()) return;

    if (trigger.matches('[data-show-search-trigger]')) e.preventDefault();
    header().openSearch(trigger);
  });

  document.addEventListener('keydown', function (e) {
    if (!header()) return;

    if (e.key === 'Escape') {
      const jq = window.jQuery;
      const popupOpen = jq && jq.fancybox && jq.fancybox.getInstance() &&
        document.querySelector('.fancybox-container .js-search-popup');
      if (popupOpen || document.querySelector('.mobile-search--visible')) header().hideSearch();
      return;
    }

    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!e.target.matches || !e.target.matches('[data-show-search-trigger]')) return;

    e.preventDefault();
    header().openSearch(e.target);
  });

  const emptyField = (form) => {
    const field = form && form.querySelector('input[name="q"]');
    return field && !field.value.trim() ? field : null;
  };

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !(e.target instanceof Element) || !e.target.matches(SEARCH_FIELD)) return;
    if (e.target.value.trim() || document.querySelector('.boost-sd__suggestion-queries-item-selected')) return;

    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  window.addEventListener('click', (e) => {
    const button = e.target instanceof Element && e.target.closest(SEARCH_SUBMIT);
    const field = button && emptyField(button.closest('form'));
    if (!field) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    field.focus();
  }, true);

  window.addEventListener('touchstart', (e) => {
    const button = e.target instanceof Element && e.target.closest(SEARCH_SUBMIT);
    if (button && emptyField(button.closest('form'))) e.stopImmediatePropagation();
  }, { capture: true, passive: true });

  document.addEventListener('submit', function (e) {
    const field = emptyField(e.target.closest && e.target.closest('.search-popup__form, .boost-sd__search-bar'));
    if (!field) return;

    e.preventDefault();
    field.focus();
  }, true);
})();

/******/ })()
;
